import { render, staticRenderFns } from "./AffectTypeGrid.vue?vue&type=template&id=313fbdfe"
import script from "./AffectTypeGrid.vue?vue&type=script&lang=js"
export * from "./AffectTypeGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports